import _debounce from 'lodash/debounce'

export const errors = {
  methods: {
    $_errors_handleError500: _debounce(function() {
      this.$message.error(this.$t('messages.errors.unknown'))
    }, 300)
  }
}
